// Copied from https://www.stitchfix.com/product/items/1179405
import { GetCreditIncentivesEligibilityQuery } from './getCreditIncentivesEligibility';

type GetCreditIncentivesEligibilityQueryWrapper = {
  data: GetCreditIncentivesEligibilityQuery;
  extensions: {
    cost: {
      'graphql-api': {
        maxQueryCost: number;
        requestedQueryCost: number;
        actualQueryCost: number;
      };
    };
  };
};

export default {
  data: {
    visitor: {
      id: '47cfbabb-98a8-4544-b329-1d9aa46156d0',
      configParams: [
        {
          name: 'eng.kufak.freestyle.credit_incentive.test_case_1',
          value: 'Accessible',
          __typename: 'ConfigParam',
        },
      ],
      __typename: 'Visitor',
    },
  },
  extensions: {
    cost: {
      'graphql-api': {
        maxQueryCost: 5000,
        requestedQueryCost: 7,
        actualQueryCost: 5,
      },
    },
  },
} as GetCreditIncentivesEligibilityQueryWrapper;
